<template>
  <div class="loginwrapper">
    <div class="lg-inner-column">
      <div class="right-column relative">
        <div class="inner-content h-full flex flex-col bg-white dark:bg-slate-800">
          <div class="auth-box h-full flex flex-col justify-center">
            <div class="mobile-logo text-center mb-6 lg:hidden block">
              <router-link to="/">
                <img
                    :src="logoWhite"
                    alt=""
                    class="mx-auto"
                />
              </router-link>
            </div>
            <div class="text-center 2xl:mb-10 mb-4">
              <h4 class="font-medium">{{ $t('message.signin') }}</h4>
              <div class="text-slate-500 text-base">
                {{ $t('message.signin_to_your_account') }}
              </div>
            </div>
            <SignIn/>
            <div class="relative border-b-[#9AA2AF] border-opacity-[16%] border-b pt-6">
              <div class="absolute inline-block bg-white dark:bg-slate-800 dark:text-slate-400 left-1/2 top-1/2 transform -translate-x-1/2 px-4 min-w-max text-sm text-slate-500 font-normal">
                Or
              </div>
            </div>
            <div class="mt-8 w-full">
              <Social/>
            </div>
          </div>
          <div class="auth-footer text-center">
            {{ $t('message.copyright') }}
          </div>
        </div>
      </div>
      <div class="left-column relative z-[1]">
        <div class="w-full pt-20 flex justify-center">
          <router-link to="/">
            <div class="w-52">
              <img
                  :src="logoWhite"
                  alt=""
                  class="mb-10 w-full"
              />
            </div>
          </router-link>
        </div>
        <div class="absolute left-0 bottom-[0px] h-[72%] w-full z-[-1]">
          <img
              :src="sideImg"
              alt=""
              class="h-full w-full object-contain"
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import SignIn from "@/views/auth/common/Signin.vue";
import Social from "@/views/auth/common/Social.vue";
import {useThemeSettingsStore} from "@/stores/themeSettings.js";
// Image Import
import logoWhite from "@/assets/images/logo/logo-white4.png"
import sideImg from "@/assets/images/auth/ils1.webp"
import {config} from "@/config.js"
import {Icon} from "@iconify/vue";

export default {
  data() {
    return {
      logoWhite, sideImg
    }
  },
  components: {
    Social,
    SignIn,
    Icon
  },
  setup() {
    const themeSettingsStore = useThemeSettingsStore();
    return {
      config,
      themeSettingsStore
    }
  }
};
</script>
<style lang="scss"></style>
